<template>
  <div>
    <div v-for="year in yearsCount" class="form-row">
      <div class="form-unit">
        <div class="light-label">{{ year }} year</div>
      </div>
      <div class="form-unit">
        <roe-vesting-percent-input
          :class="inputClass"
          :design="design"
          :number="year"
          :type="type"
        >
        </roe-vesting-percent-input>
      </div>
      <div class="form-unit"></div>
    </div>
  </div>
</template>

<script>
import RoeVestingPercentInput from "@/components/_shared/inputs/design/VestingPercentInput";
export default {
  name: "RoeVestingPercentInputs",
  components: { RoeVestingPercentInput },
  props: {
    design: Object,
    inputClass: String,
    type: {
      type: String,
      default() {
        return "other";
      }
    },
    yearsCount: {
      type: Number,
      default() {
        return 6;
      }
    }
  }
};
</script>
